import { render, staticRenderFns } from "./PromotionDiscountListItem.vue?vue&type=template&id=7f56d530&"
import script from "./PromotionDiscountListItem.vue?vue&type=script&lang=js&"
export * from "./PromotionDiscountListItem.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDiscountListItem.vue?vue&type=style&index=0&id=7f56d530&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports